enum ChipsVariantEnum {
  FILLED = 'filled',
  BORDERED = 'bordered',
}

export default ChipsVariantEnum;
